import React from 'react';
import logo from '../../static/img/logo.png';

const Logo = ({ width = '500px', height = '500px' }) => {
  return <img width={width} src={logo} alt="" />;
};

export default Logo;
